module.exports = __webpack_public_path__ + "img/Alexey-Belovs.28abb30a.png";